import React from 'react';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <span>© {new Date().getFullYear()} ZenLog</span>
        <span>Crafted with calm</span>
      </div>
    </footer>
  );
}

export default Footer;
